import PharmacyPage from './PharmacyPage';

export default PharmacyPage;
